// Requires `js--modules--Arrows.min.js`


/**
 * Product Options and Add-to-Cart Button
 */
(function() {
  const form = document.getElementById('AddToCartForm');
  const isOneOfAKind = 'isOneOfAKind' in form.dataset;
  const addToCartButton = form.querySelector('#js-AddToCart');

  const options = form.querySelectorAll('.options--input');
  if (options.length) {
    const variants = getVariantsBySize();
    const hiddenVariantInput = form.querySelector('#js-variant-id');
    const cartVariantIds = form.dataset.cartVariantIds.split(',').map(id => Number(id));
    const productPrice = document.querySelector('#js-ProductPrice');
    const comparePrice = document.querySelector('#js-ComparePrice');
    const productSku = document.querySelector('#js-product-sku');
    const sizeInfoSku = document.querySelector('#js-sizing-contact__input--sku');
    const url = new URL(window.location);
    const urlParams = new URLSearchParams(url.search);

    options.forEach(o => o.addEventListener('change', evt => {
      const size = evt.target.value;
      const variant = variants[size];
      updateAddToCartButton(variant.id, variant.inventory_policy, variant.inventory_quantity);
      updateHiddenVariantInput(variant.id);
      updatePrices(variant.price, variant.compare_at_price);
      updateSkus(variant.sku);
      updateUrlSearchParams(variant.id);
    }));

    function getVariantsBySize() {
      const json = JSON.parse(form.querySelector('#product-variants').textContent);
      return Object.fromEntries(json.map(v => [v.option1, v]));
    }
    function updateAddToCartButton(variantId, inventoryPolicy, inventoryQuantity) {
      const isAvailable = (inventoryPolicy === 'continue' || inventoryQuantity > 0);
      if (isAvailable) {
        if (isOneOfAKind && cartVariantIds.includes(variantId)) {
          addToCartButton.disabled = true;
        } else {
          addToCartButton.disabled = false;
        }
        addToCartButton.textContent = 'Add to Cart';
      } else {
        addToCartButton.disabled = true;
        addToCartButton.textContent = 'Sold Out';
      }
    }
    function updateHiddenVariantInput(variantId) {
      hiddenVariantInput.value = variantId;
    }
    function updatePrices(price, compareAtPrice) {
      if (productPrice.dataset.price === price) return;
      productPrice.dataset.price = price;
      productPrice.innerHTML = window.APP.convertPrice.convert(price);
      window.APP.convertPrice.refreshList();
      if (comparePrice) {
        if (compareAtPrice > price) {
          comparePrice.innerHTML = window.APP.convertPrice.convert(compareAtPrice);
          comparePrice.style.display = 'block';
        } else {
          comparePrice.style.display = 'none';
        }
      }
    }
    function updateSkus(sku) {
      productSku.textContent = sku;
      if (sizeInfoSku) sizeInfoSku.value = sku;
    }
    function updateUrlSearchParams(variantId) {
      urlParams.set('variant', variantId);
      url.search = urlParams.toString();
      history.pushState({}, '', url.href);
    }
  }

  addToCartButton.addEventListener('click', (evt) => {
    evt.preventDefault();
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: (function getFormData() {
        const formObject = {};
        (new FormData(form)).forEach((value, key) => {
          if (key.startsWith('properties[')) {
            const propertyKey = key.match(/\[(.*?)\]/)[1];
            try {
              return formObject.properties[propertyKey] = value;
            } catch {
              return formObject.properties = { [propertyKey]: value };
            }
          } else {
            return formObject[key] = value;
          }
        });
        return JSON.stringify(formObject);
      })(),
    })
    .then((res) => {
      if (!res.ok) throw `HTTP response status code: ${res.status}`;

      if (isOneOfAKind) addToCartButton.disabled = true;
      document.querySelector('#js-addToCartResponse').hidden = false;
      window.APP.updateCartCount(1);
    })
    .catch((err) => {
      window.APP.gaError('Add To Cart', err);
      // On error, revert to default form submission (AKA open the cart page.)
      form.submit();
    });
  });
})();


/**
 * Photo Galleries (Main and Modal) ============================================
 */
(function() {
  // Shared --------------------------------------------------------------------
  const swipeSettings = {
    speed: window.APP.config.carouselTransitionDur,
    continuous: false,
  };
  let isModalOpen = false;

  /**
   * Manage playback state and position in a given set of videos.
   *
   * @property {object} index
   * @property {boolean} any
   */
  class Videos {
    /**
     * @param {NodeList} videoElements
     * @param {boolean} [autoplay=false] Autoplay if the first gallery item is a
     *   video.
     */
    constructor(videoElements, autoplay = false) {
      this.index = Object.fromEntries(
        Array.from(videoElements).map(video => [video.dataset.index, video])
      );
      this.any = (Object.keys(this.index).length > 0);
      if (autoplay && this.index[0]) {
        this.play(0);
      }
    }

    /**
     * @param {number} key
     */
    pause(key) {
      const video = this.#getVideo(key);
      if (video) this.#pause(video);
    }

    pauseAll() {
      Object.values(this.index).forEach(video => this.#pause(video));
    }

    /**
     * @param {number} key
     */
    play(key) {
      const video = this.#getVideo(key);
      if (video) this.#play(video);
    }

    /**
     * @returns {object}
     */
    getPositions() {
      return Object.fromEntries(
        Object.entries(this.index).map(([i, video]) => [i, video.currentTime])
      );
    }

    /**
     * @param {object} positions
     */
    setPositions(positions) {
      Object.entries(this.index).forEach(([i, video]) => video.currentTime = positions[i]);
    }

    resetManualPauses() {
      Object.values(this.index).forEach(video => video.removeAttribute('data-paused-manually'));
    }

    /**
     * @param {number} key
     * @param {boolean} [isManual=false]
     */
    toggle(key, isManual = false) {
      const video = this.#getVideo(key);
      if (video) {
        if (video.paused) this.#play(video, isManual);
        else this.#pause(video, isManual);
      }
    }

    /**
     * @param {Node} video
     * @param {boolean} [isManual=false]
     */
    #pause(video, isManual = false) {
      video.pause();
      video.removeAttribute('data-is-playing');
      if (isManual) {
        video.setAttribute('data-paused-manually', '');
      }
    }

    /**
     * @param {Node} video
     * @param {boolean} [isManual=false]
     */
    async #play(video, isManual = false) {
      /**
       * If video has been manually paused, the pause-state should be respected
       * and thus playback should only be resumed manually. The only exception
       * is on exit from the modal video as the gallery video should match the
       * state of the modal video. Otherwise, autoplay via the carousel
       * controller should be disabled.
       */
      if (video.hasAttribute('data-paused-manually') && isManual === false) return;

      /**
       * On error, show the play button in order to strongly hint that it is a
       * video. Errors will not be uncommon as, for instance, iOS devices in
       * Lower Power Mode disables autoplay. If subsequent attempts are
       * successful, whether triggered manually or automatically via the
       * carousel controls, remove the `data-autoplay-error` flag.
       */
      try {
        await video.play();
        video.setAttribute('data-is-playing', '');
        video.removeAttribute('data-autoplay-error');
        video.removeAttribute('data-paused-manually');
      } catch(err) {
        video.setAttribute('data-autoplay-error', '');
      }
    }

    /**
     * @param {number} key
     * @returns {Node}
     */
    #getVideo(key) {
      return this.index[String(key)];
    }
  }

  /**
   * Manage 3D product model's rotational state, camera control state, and UI.
   */
  class Model {
    /**
     * @param {HTMLElement} model
     */
    constructor(model) {
      this.model = model;
      this.viewer = model.querySelector('model-viewer');
      this.toggle = model.querySelector('form');
      this.defaultAutoRotateDelay = this.viewer.autoRotateDelay;
      this.hasInteracted = false;
      this.eventCallbacks = {
        changeModel: [],
        changeSwipe: [],
        clickViewer: [],
      }

      this.#addEventListenerForClickViewer();
      if (window.isTouchDevice()) {
        this.#disableCameraControl();
        this.#addEventListenerForChangeSwipe();
        this.#addEventListenerForChangeModel();
      }
    }

    /**
     * Add function to run each time a select event is triggered.
     *
     * @param {'changeSwipe' | 'changeModel' | 'clickViewer'} eventName
     * @param {Function} callback
     */
    addEventCallback(eventName, callback) {
      this.eventCallbacks[eventName]?.push(callback);
    }

    /**
     * @typedef Positions
     * @type {object}
     * @property {string} cameraOrbit E.g. `10deg 75deg 1.5m`
     * @property {number} fieldOfView
     * @property {number} turntableRotation
     */
    /**
     * @returns {Positions}
     */
    get positions() {
      return {
        cameraOrbit: this.viewer.getCameraOrbit().toString(),
        fieldOfView: this.viewer.getFieldOfView(),
        turntableRotation: this.viewer.turntableRotation,
      };
    }

    /**
     * @param {Positions} pos
     */
    set positions(pos) {
      this.viewer.cameraOrbit = pos.cameraOrbit;
      this.viewer.fieldOfView = pos.fieldOfView;
      this.viewer.resetTurntableRotation(pos.turntableRotation);
    }

    /**
     * @returns {boolean}
     */
    get isRotating() {
      return this.viewer.autoRotate;
    }

    startRotation() {
      this.viewer.autoRotateDelay = this.hasInteracted ? this.defaultAutoRotateDelay : 1;
      this.viewer.autoRotate = true;
    }

    stopRotation() {
      this.viewer.autoRotate = false;
    }

    /**
     * @returns {'swipe' | 'model'}
     */
    get toggleState() {
      return this.toggle.querySelector('input:checked').value;
    }

    /**
     * @param {'swipe' | 'model'} stateName
     */
    set toggleState(stateName) {
      if (this.toggleState === stateName) return;
      // Checking an input automatically unchecks the other input.
      this.toggle.querySelector('input:not(:checked)').checked = true;
      this.toggle.querySelector('input:checked').dispatchEvent(new Event('change'));
    }

    #addEventListenerForChangeSwipe() {
      this.toggle.querySelector('input[value="swipe"]').addEventListener('change', () => {
        this.#disableCameraControl();
        this.eventCallbacks.changeSwipe.forEach(cb => cb());
      });
    }

    #addEventListenerForChangeModel() {
      this.toggle.querySelector('input[value="model"]').addEventListener('change', () => {
        this.#enableCameraControl();
        this.eventCallbacks.changeModel.forEach(cb => cb());
      });
    }

    #addEventListenerForClickViewer() {
      let startTime;
      this.viewer.addEventListener('mousedown', () => {
        startTime = new Date();
      });
      this.viewer.addEventListener('mouseup', evt => {
        const endTime = new Date();
        const delta = endTime - startTime;
        if (delta < 100) this.eventCallbacks.clickViewer.forEach(cb => cb(evt));
      });
    }

    #disableCameraControl() {
      this.viewer.cameraControls = false;
    }

    #enableCameraControl() {
      this.viewer.cameraControls = true;
    }
  }

  // Main Gallery --------------------------------------------------------------
  const carousel = document.querySelector('#js-product-gallery__main');
  const carouselLinks = carousel.querySelectorAll('.js-c-media-carousel--link');
  const thumbs = document.querySelector('#js-product-gallery__thumbs');
  const mediaCnt = thumbs.children.length;
  const prevArrow = carousel.querySelector('.slick-prev');
  const nextArrow = carousel.querySelector('.slick-next');
  const arrows = new window.APP.Arrows(mediaCnt, prevArrow, nextArrow);
  const videos = new Videos(carousel.querySelectorAll('video'), true);
  const modelElement = carousel.querySelector('#js-main-model');
  const model = modelElement ? new Model(modelElement) : null;

  // Init Swipe
  const swipe = new Swipe(carousel, {
    ...swipeSettings,
    callback: (index, element) => {
      arrows.update(index);
      if (videos.any && !isModalOpen) {
        videos.pauseAll();
        videos.play(index);
      }
      if (model) {
        if (element.dataset.mediaType === 'model') {
          model.startRotation();
        } else {
          model.stopRotation();
        }
      }

      // Toggle thumbs status
      thumbs.querySelector(':disabled').removeAttribute('disabled');
      thumbs.querySelector(`#js-thumb-i-${index}`).setAttribute('disabled', '');
    },
  });

  // Add callbacks to Model
  if (model) {
    model.addEventCallback('changeSwipe', () => {
      swipe.enable();
      thumbs.classList.remove('c-media-carousel--thumbs__disabled');
    });
    model.addEventCallback('changeModel', () => {
      swipe.disable();
      thumbs.classList.add('c-media-carousel--thumbs__disabled');
    });
  }

  // Add event listeners
  prevArrow.addEventListener('click', () => swipe.prev());
  nextArrow.addEventListener('click', () => swipe.next());
  document.addEventListener('keydown', (evt) => {
    switch(evt.code) {
      case 'ArrowLeft': !isModalOpen && swipe.prev(); break;
      case 'ArrowRight': !isModalOpen && swipe.next(); break;
    }
  });
  thumbs.querySelectorAll('button').forEach(button => {
    button.addEventListener('click', () => swipe.slide(button.dataset.thumbI));
  });

  // Video Controller
  if (videos.any) {
    const controllerVisibility = (() => {
      const fadeAfterDelay = (() => {
        let timer; // Timer must be shared across calls.
        return function(controller) {
          clearTimeout(timer);
          controller.classList.remove('js-product-media-video-controller__fade-out')
          timer = setTimeout(() => {
            controller.classList.add('js-product-media-video-controller__fade-out');
          }, 1000);
        }
      })();

      const showTemporarily = (controller) => {
        controller.classList.add('js-product-media-video-controller__touched');
        setTimeout(() => {
          controller.classList.remove('js-product-media-video-controller__touched');
        }, 1500);
      };

      return {
        fadeAfterDelay,
        showTemporarily,
      }
    })();

    Object.values(videos.index).forEach(video => {
      const slide = video.parentNode.parentNode;
      const controller = slide.querySelector('.product-media-video-controller');

      // On touch devices, JS "click" events and CSS :hover and :active states
      // conflict for unknown reasons, requiring the user to inexplicably "click"
      // twice before the video controller becomes responsive.
      controller.addEventListener('pointerdown', (evt) => {
        videos.toggle(video.dataset.index, true);

        // Reactivate video controller.
        controllerVisibility.fadeAfterDelay(controller);

        // Provide touch feedback (eventually fading out.) CSS :hover actions on
        // touch devices have been disabled due to its "sticky" behavior.
        if (evt.pointerType !== 'mouse') controllerVisibility.showTemporarily(controller);
      }, { passive: true });

      // On pointer halt, fade out the video controller, even during hover.
      slide.addEventListener('pointermove', () => {
        controllerVisibility.fadeAfterDelay(controller);
      }, { passive: true });

      // Ensure video controller appears on touch anywhere on the video-slide (such
      // as during a swipe gesture) in order provide discoverability of the UI.
      slide.addEventListener('pointerdown', (evt) => {
        if (evt.pointerType !== 'mouse') controllerVisibility.showTemporarily(controller);
      }, { passive: true });
    });
  }

  // Defer-load carousel images
  document.querySelectorAll('.js-defer-load').forEach(img => {
    img.src = window.APP.imgURL(
      img.dataset.master, { img_url: img.dataset.srcDimension, crop: 'center' }
    );

    img.srcset =
      img.dataset.srcsetDimensions.split(',').reduce((srcset, dimension) => {
        const url = window.APP.imgURL(
          img.dataset.master, { img_url: dimension, crop: 'center' }
        );
        const width = `${dimension.split('x')[0]}w`;
        return `${srcset}${url} ${width},`
      }, '').slice(0, -1);
  });

  // Fix video element size glitch on macOS Safari (as of February 2023.)
  document.addEventListener('DOMContentLoaded', () => {
    Object.values(videos.index).forEach(video => video.style.width = '100%');
  });

  // Modal Gallery -------------------------------------------------------------
  {
    const modalGallery = document.querySelector('#js-product-gallery__modal');
    const modalCarousel = modalGallery.querySelector('#js-product-gallery__modal-carousel');
    const prevArrow = modalCarousel.querySelector('.slick-prev');
    const nextArrow = modalCarousel.querySelector('.slick-next');
    const modalArrows = new window.APP.Arrows(mediaCnt, prevArrow, nextArrow);
    const modalVideos = new Videos(modalCarousel.querySelectorAll('video'));
    const modalModelElement = modalCarousel.querySelector('#js-modal-model');
    const modalModel = modalModelElement ? new Model(modalModelElement) : null;
    const stageLight = window.APP.attachStageLight(modalGallery.querySelector('.js-stage-light'));
    const closeModalLinks = modalGallery.querySelectorAll('.js-close-modal-popup');

    // Init Swipe
    const modalSwipe = new Swipe(modalCarousel, {
      ...swipeSettings,
      callback: (index, element) => {
        modalArrows.update(index);
        if (videos.any) {
          modalVideos.pauseAll();
          modalVideos.play(index);
        }
        if (modalModel) {
          if (element.dataset.mediaType === 'model') {
            modalModel.startRotation();
          } else {
            modalModel.stopRotation();
          }
        }
      },
    });

    // Add callbacks to Modal Model
    if (modalModel) {
      modalModel.addEventCallback('changeSwipe', () => modalSwipe.enable());
      modalModel.addEventCallback('changeModel', () => modalSwipe.disable());
    }

    const handleOpenModal = (evt) => {
      const index = evt.srcElement.offsetParent.dataset.index;
      evt.preventDefault();
      isModalOpen = true;
      stageLight.dim();
      modalGallery.style.display = 'block';
      modalSwipe.setup(); // Initial setup above cannot set element widths when `display: none`
      modalSwipe.slide(index);
      if (videos.any) {
        videos.pause(index)
        modalVideos.setPositions(videos.getPositions());
        modalVideos.play(index);
      }
      if (model) {
        if (model.isRotating) modalModel.startRotation();
        model.stopRotation();
        modalModel.positions = model.positions;
        modalModel.toggleState = model.toggleState;
      }
    };

    const handleCloseModal = () => {
      const index = modalSwipe.getPos();
      isModalOpen = false;
      stageLight.restore();
      modalGallery.style.display = 'none';
      swipe.slide(index);
      if (videos.any) {
        modalVideos.pauseAll;
        videos.resetManualPauses();
        videos.setPositions(modalVideos.getPositions());
        videos.play(index);
      }
      if (model) {
        if (modalModel.isRotating) model.startRotation();
        modalModel.stopRotation();
        model.positions = modalModel.positions;
        model.toggleState = modalModel.toggleState;
      }
    };

    // Add event listeners
    carouselLinks.forEach(link => link.addEventListener('click', handleOpenModal));

    // Enable clicking on the model to open its modal view.
    if (model) {
      model.addEventCallback('clickViewer', evt => handleOpenModal(evt));
    }

    closeModalLinks.forEach(button => button.addEventListener('click', handleCloseModal));
    prevArrow.addEventListener('click', () => modalSwipe.prev());
    nextArrow.addEventListener('click', () => modalSwipe.next());
    document.addEventListener('keydown', (evt) => {
      switch(evt.code) {
        case 'ArrowLeft': modalSwipe.prev(); break;
        case 'ArrowRight': modalSwipe.next(); break;
        case 'Escape': handleCloseModal(); break;
      }
    });
  }

  /**
   * TODO: This is a stop-gap measure for products with only a single media
   * item. The carousel continues to be activated and so, with nothing to do,
   * its UI is merely removed. The correct behavior is simply for the carousel
   * to never be activated.
   */
  if (mediaCnt <= 1) {
    // Remove main and modal carousel arrows
    document.querySelectorAll('.slick-arrow').forEach(el => el.remove());
  }
})();


/**
 * Product Recommend ===========================================================
 */
(function() {
  fetch(`/recommendations/products.json?product_id=${window.APP.productID}`)
    .then((res) => {
      if (!res.ok) throw `HTTP response status code: ${res.status}`;
      return res.json();
    })
    .then((json) => {
      /**
       * iPhone 6/7/8 (2×)       228 px
       * iPhone X (3×)           342 px
       * iPhone 6/7/8 Plus (3×)  381 px
       * 3-up widest (599px)     161 px
       * 4-up narrowest (600px)  121 px
       * 4-up widest (949px)     208 px
       * 5-up narrowest (950px)  166 px
       * 5-up widest (1180px)    215 px
       */
      let html = '';
      json.products.forEach(prod => {
        if (prod.featured_image === null) return;
        const featuredImageUrl = `https:${prod.featured_image}`;
        html += `
          <li class="product-grid-item product-grid-item__invert cross-sell--item">
            <a href="${prod.url}" class="product-grid-image-link">
              <img class="product-grid-image auto"
                    src="${window.APP.imgURL(featuredImageUrl, {img_url: '215x'})}"
                    sizes="(max-width: 480px) calc((100vw - 30px) / 3 - 1px),
                           (max-width: 599px) calc((100vw - 30px - 70px) / 3 - 1px),
                           (max-width: 949px) calc((100vw - 30px - 70px) / 4 - 1px),
                           215px"
                    srcset="${window.APP.imgURL(featuredImageUrl, {img_url: '166x'})} 166w,
                            ${window.APP.imgURL(featuredImageUrl, {img_url: '228x'})} 228w,
                            ${window.APP.imgURL(featuredImageUrl, {img_url: '381x'})} 381w"
                    alt=""
                    loading="lazy">
            </a>
            <p class="product-grid-title"><a class="product-grid-title-link" href="${prod.url}">${prod.title}</a></p>
          </li>`;
      });

      if (html !== '') {
        document.querySelector('#js-product-rec--list').innerHTML = html;
        document.querySelector('#js-product-rec').hidden = false;
      }
    })
    .catch((err) => window.APP.gaError('Product Recommend', err));
})();


/**
 * Miscellaneous ===============================================================
 */
(function() {

  // Payment Installment Info --------------------------------------------------
  const paymentButton = document.querySelector('#js-payment-installment-promo');
  if (paymentButton) {
    paymentButton.onclick = () => paymentButton.classList.toggle('js-payment-installment-promo__active');
  }

  // Sizing Info (Contact) -----------------------------------------------------
  // Focus the "name" field on click.
  document.querySelector('#js-goto-sizing-contact')?.addEventListener('click', () => {
    // Unsure why but focus doesn't work otherwise
    window.setTimeout(() => {
      document.querySelector('#js-sizing-contact__input--name').focus();
    }, 0);
  });

  // Add a hidden field w/ Google Analytics client ID --------------------------
  window.APP.addGAFormField('contact_form');
})();
